module.exports = __webpack_public_path__ + "static/tecnologias-35860a681ddc255f0a5458b5a3e9d58d.svg";